import React from "react";

const About = () => {
  return (
    <div className="font-josefin-sans flex flex-col items-center justify-center gap-5 ">
      {/* Banner */}
      <div className="px-5 py-28 lg:px-44 lg:h-screen bg-gradient-to-r from-green-400 to-cyan-400 flex justify-center items-center w-full ">
        <h2 className="text-5xl font-bold text-white text-center">
          We are enablers & doers of Quality Education
        </h2>
      </div>
      <div className="px-5 mt-14 lg:mt-28 flex flex-col items-center justify-center max-w-xl  text-center">
        <h3 className="text-2xl lg:text-3xl  font-bold">About Us</h3>
        <p className="text-lg lg:text-lg">
          An online platform to provide solutions to conceptual, technical and
          practical problems in science, technology, engineering and mathematics
          using a human plus machine approach.
        </p>
      </div>
      <div className="px-5  flex flex-col items-center justify-center max-w-xl  text-center">
        <h3 className="text-2xl lg:text-3xl font-bold">Mission</h3>
        <p className="text-lg lg:text-lg">
          To make each student & fresher in higher education to stay on top of
          their career by providing quality solutions to their tech problems.
        </p>
      </div>
      <div className="px-5  flex flex-col items-center justify-center max-w-xl  text-center ">
        <h3 className="text-2xl lg:text-3xl font-bold">Vision</h3>
        <p className="text-lg lg:text-lg">
          To create the best possible career & economic opportunity for every
          student & fresher.
        </p>
      </div>
    </div>
  );
};

export default About;
